/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Ei mainintoja'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Mainitsit Prozisin Instagramissa sinä päivänä. {publishedAt}',
    NO_ROWS_MENTIONS: 'Et ole vielä maininnut prozista Instagramissa.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
